// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:g7l23y */\n.IiPIR{align-items:center;display:grid;grid-template-columns:6rem min-content 6rem;justify-content:center;padding:var(--audio-spacing-8) 0;width:100%}.WCQ34{margin-right:auto}.ngxKI{display:inline-flex;margin-left:auto}._58S5h{color:var(--audio-exception-light);display:inline-flex}.xdHV5{height:2rem;width:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": "IiPIR",
	"share": "WCQ34",
	"trailing": "ngxKI",
	"iconButton": "_58S5h",
	"icon": "xdHV5"
};
export default ___CSS_LOADER_EXPORT___;
